import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'TR',
    name: 'Rampaging Vin',
    id: 'RampagingVin',
    health: 60,
    difficulty: 8,
    expeditionRating: 4,
	fightFiveAdditionalInfo: `
	<p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
	<p>SETUP: Gravehold suffers 8 damage.</p>
	`,
    additionalInfo: '',
  },
]
